export var TextESGRating = function TextESGRating(_ref) {
  var value = _ref.value;
  return '';
};
export default TextESGRating;